export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.No",
  },
  {
    id: "branchName",
    numeric: false,
    disablePadding: true,
    label: "Branch Name",
  },
  {
    id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "onboaderdon",
    numeric: true,
    disablePadding: false,
    label: "Onboarded on",
  },
  {
    id: "phone",
    numeric: true,
    disablePadding: false,
    label: "Phone",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  
  // Get the day, month, and year
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // 'FEB'
  const year = date.getFullYear();

  // Get the time in 12-hour format with AM/PM
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = (hours % 12) || 12; // Convert to 12-hour format

  // Combine date and time as per your requirement: "21 FEB 2023 | 08:24 AM"
  return `${day} ${month} ${year} | ${formattedHours}:${minutes} ${ampm}`;
};